import React from 'react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    limit: number;
    onPageChange: (page: number) => void;
}

const PaginationRounded: React.FC<PaginationProps> = ({ currentPage, totalPages, limit, onPageChange }) => {
  const handlePrevious = () => {
      onPageChange(Math.max(currentPage - 1, 1));
  };

  const handleNext = () => {
      onPageChange(Math.min(currentPage + 1, totalPages));
  };

  console.log("currentPage",currentPage);
  console.log("totalPages",totalPages);
  
  
  const showPagesBetween = (start: number, end: number) => {
    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          style={{
            padding: "8px 16px",
            margin: "0 4px",
            backgroundColor: currentPage === i ? "#008564" : "#2E4051",
            color: currentPage === i ? "#ffffff" : "#ffffff",
            borderRadius: "4px",
            cursor: "pointer",
            border: currentPage === i ? "1px solid #008564 " : "1px solid #2E4051" 
          }}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  const showPreviousButton = currentPage > 1;
  const showNextButton = currentPage < totalPages;
  
  if (totalPages === 0) {
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        {showPreviousButton && (
            <button
                onClick={handlePrevious}
                style={{ padding: "8px 16px", margin: "0 4px", backgroundColor: "#2E4051", color: "#ffffff", borderRadius: "4px", cursor: "pointer", border: "1px solid #2E4051" }}
            >
               Previous
            </button>
        )}

        {showPagesBetween(1, totalPages)}

        {showNextButton && (
            <button
                onClick={handleNext}
                style={{ padding: "8px 16px", margin: "0 4px", backgroundColor: "#2E4051", color: "#ffffff", borderRadius: "4px", cursor: "pointer", border: "1px solid #2E4051" }}
            >
                Next
            </button>
        )}
    </div>
  );
};

export default PaginationRounded;